export default __webpack_public_path__ + "static/media/Group_3860.b56c8db9.svg";